import React, {useContext, useEffect, useMemo, useState} from 'react';
import {useDispatch} from 'react-redux';
import styled from 'styled-components';
import {createDocumentCopy, createTaskDocumentRelation} from '../../../../actions/Task/taskdetaildocumentsaction';
import {useDocumentUploadStatus} from '../../DocumentName/DocumentName.utils';
import {
	deleteRelatedDocument,
	createFormBodyReference
} from '../../../../actions/RelatedDocuments/relatedDocumentsActions';
import {useEngagementId} from '../../../../util/customHooks';
import {
	relateDocumentsTo,
	relatedDocumentsTab,
	clientSideEventNames,
	documentSources,
	documentTypes,
	CopyDocumentNameBehaviorType,
	documentTabLayoutTabs
} from '../../../../util/uiconstants';
import Utility from '../../../../util/utilityfunctions';
import {labels} from '../../../../util/utils';
import DocumentName from '../../DocumentName/DocumentName';
import NotesCount from '../../ReviewNotes/NotesCount';
import SignOffs from '../../SignOffs/SignOffs';
import {documentNameMaxLength} from '../../../../util/uiconstants';
import {setIsModalOpen} from '../../../../actions/setismodalopen';
import {useAresUrlParameters} from '../../../../util/Ares/customHooks';
import AddToEvidence from './AddToEvidence';
import {SectionIdContext} from './Context';
import {useSelector} from 'react-redux';
import {raiseInformationMessage} from '../../../../actions/erroractions';
import {updateDocumentMetadata} from '../../../../actions/Document/documentactions';
import MotifTooltip from '../../BaseComponentWrappers/MotifTooltip';
import Icon from '../../BaseComponentWrappers/MotifIcon';
import {fileIcFileDownload24px} from '@ey/motif-react-wrapper/assets/icons/index';
import RelatedTasksIcon from './RelatedTasks/RelatedTasksIcon';

export default function RelatedDocumentsItem({
	userPreferences,
	document,
	isTargetEng,
	documentId,
	isFormQuickReference,
	bodyId,
	loadRelatedDocuments,
	setUpdateReferenceDocCount,
	setBodyToUpdate,
	entityUId,
	isFromDocumentUpload,
	removeDocumentFromBody,
	parentContainerClassName,
	showOptions = true,
	showMenuOptions = true,
	isAresView = false,
	activeTab,
	requireValidations = false,
	parentName,
	isDragAndDropDoc,
	enablePriorPeriodOptions = false,
	enableTemporaryOptions = false,
	enableExternalDocumentsOptions = false,
	filteredEntityType,
	getRelatedDocuments,
	canvasFormOpenType,
	relatedTasks,
	isGroupRiskAssessmentSection = false,
	instructionId,
	showRelatedTasks = false,
	hasRelateTaskOption = false,
	showNotes = true,
	showSignOffs = true,
	isModalOpen = false,
	setResetKey,
	isFromRelatedDocumentsModal,
	isDisabled,
	groupInstructionDrawer = false,
	itemClassName
}) {
	const [stateDocument, setDocument] = useState(document);
	const [approvals, setApprovals] = useState([]);
	const [copyInProgress, setCopyInProgress] = useState(false);
	const [showAddtoEvidenceModal, setShowAddtoEvidenceModal] = useState(false);
	const [textAreaError, setTextAreaError] = useState(false);
	const [error, setError] = useState();
	const [errorMessage, setErrorMessage] = useState();
	const [documentName, setDocumentName] = useState(document.documentName);
	const [clearError, setclearError] = useState(false);

	const aresUrlParameters = useAresUrlParameters();

	const contextSectionId = useContext(SectionIdContext);

	const sectionId = useMemo(() => contextSectionId || aresUrlParameters.sectionId, [
		contextSectionId,
		aresUrlParameters
	]);

	const viewKey = useMemo(() => (isFormQuickReference ? 'FORM_QUICK_REFERENCE' : 'FORM_BODY_QUICK_REFERENCE'), [
		isFormQuickReference
	]);

	const dispatch = useDispatch();

	const engagementId = useEngagementId();

	const isPriorPeriodEvidence = Utility.isPriorPeriodEvidence(document);

	const showDocumentOptions = useMemo(() => {
		let showDocumentOptions = showOptions;

		if (showMenuOptions === false) {
			return showMenuOptions;
		}

		if ((isTargetEng && !stateDocument.isShared) || (userPreferences.isGuestUser && !userPreferences.isCEAPUser)) {
			showDocumentOptions = false;
		}

		if (isPriorPeriodEvidence && !enablePriorPeriodOptions) {
			showDocumentOptions = false;
		}

		return showDocumentOptions;
	}, [
		showOptions,
		showMenuOptions,
		isTargetEng,
		stateDocument.isShared,
		userPreferences.isGuestUser,
		userPreferences.isCEAPUser,
		isPriorPeriodEvidence,
		enablePriorPeriodOptions
	]);

	const showPriorPeriodOptions = useMemo(() => {
		return enablePriorPeriodOptions && activeTab === relatedDocumentsTab.PRIOR_PERIOD;
	}, [activeTab, enablePriorPeriodOptions]);

	const showTemporaryOptions = useMemo(() => {
		return enableTemporaryOptions && activeTab === relatedDocumentsTab.TEMPORARY;
	}, [activeTab, enableTemporaryOptions]);

	const showExternalDocumentOptions = useMemo(() => {
		return enableExternalDocumentsOptions && activeTab === relatedDocumentsTab.EXTERNAL_DOCUMENTS;
	}, [activeTab, enableExternalDocumentsOptions]);

	const removeRelatedDocument = (_, document) => {
		return dispatch(
			deleteRelatedDocument(
				engagementId,
				documentId,
				bodyId || entityUId,
				document.id,
				relateDocumentsTo.canvasFormBody
			)
		).then(() => {
			if (requireValidations) window.dispatchEvent(new CustomEvent(clientSideEventNames.getValidations));
			setUpdateReferenceDocCount && setUpdateReferenceDocCount(true);
			setBodyToUpdate && setBodyToUpdate(bodyId || entityUId);
			loadRelatedDocuments && loadRelatedDocuments();
		});
	};

	function handleOnDocumentDeleted(document, viewKey) {
		setResetKey((prev) => prev + 1);
		if (requireValidations) window.dispatchEvent(new CustomEvent(clientSideEventNames.getValidations));
		setUpdateReferenceDocCount && setUpdateReferenceDocCount(true);
		setBodyToUpdate && setBodyToUpdate(bodyId);
		loadRelatedDocuments && loadRelatedDocuments();
	}

	const priorPeriodOptions = [
		{name: 'Open', isVisible: false},
		{name: 'Rename', isVisible: false},
		{name: 'Delete', isVisible: false}
	];

	const externalDocumentOptions = [
		{name: 'Open', isVisible: false},
		{name: 'view history', isVisible: false},
		{name: 'CopyLink'},
		{name: 'Rename', isVisible: false},
		{name: 'Delete', isVisible: false},
		{name: 'RemoveFromBody', isVisible: false}
	];

	let evidenceOptions = [];
	if (!isTargetEng) {
		if (instructionId) {
			evidenceOptions = [
				{name: 'Open'},
				{name: 'Open read-only'},
				{name: 'CopyLink'},
				{name: 'Rename'},
				{name: 'RelateTasks'},
				{name: 'RelateEntities'},
				{name: 'SignoffRequirements'},
				{name: 'Delete'},
				{name: 'RemoveFromBody'}
			];
		} else {
			evidenceOptions = [
				{name: 'Open'},
				{name: 'Open read-only'},
				{name: 'Start Co-edit mode'},
				{name: 'End Co-edit mode'},
				{name: 'CopyLink'},
				{name: 'Rename'},
				{name: 'RelateTasks'},
				{name: 'RelateEntities'},
				{name: 'SignoffRequirements'},
				{name: 'Delete'},
				{name: 'RemoveFromBody'}
			];
		}
	}

	useEffect(() => {
		if (document) {
			setDocument(document);
			if (document.approvals && !isPriorPeriodEvidence) {
				setApprovals(Utility.formatGetAllDocumentsApprovalsForSignOffsControl(document.approvals, userPreferences));
			}
		}
	}, [document]);

	const {inProgress} = useDocumentUploadStatus(
		true,
		stateDocument.id,
		stateDocument.documentName,
		stateDocument.fileExt,
		isDragAndDropDoc
	);
	const showAddToEvidenceModal = (event) => {
		setclearError(true);
		setShowAddtoEvidenceModal(true);
		setDocumentName(stateDocument.documentName);
		dispatch(setIsModalOpen(true));
	};
	const validateDocumentName = (name) => {
		const [error, errorMessage] = Utility.validateDocumentName(name, true);

		setError(error);
		setErrorMessage(errorMessage);

		return [error, errorMessage];
	};

	const handlerTextAreaOnChange = (e) => {
		let value = e.target.value.slice(0, documentNameMaxLength);
		setDocumentName(value);
	};

	const taskIds = () => {
		return relatedTasks?.length > 0 ? relatedTasks.map((task) => task.taskId) : null;
	};

	const handleOnClickAddToEvidence = (event) => {
		const validationResult = validateDocumentName(documentName);
		const isValid = validationResult.every((result) => !result);

		if (!isValid) {
			setTextAreaError(true);
		} else {
			setCopyInProgress(true);
			setTextAreaError(false);

			let _documentSource = documentSources.USERGENERATED;
			if (
				stateDocument.documentTypeId === documentTypes.PRIORYEAREVIDENCE ||
				(stateDocument.fileExt && stateDocument.fileExt !== '')
			) {
				_documentSource = documentSources.SUPPORTPANEPRIORYEAREVIDENCE;
			}

			const copyArgs = {
				targetDocumentType: taskIds() ? documentTypes.EVIDENCE : documentTypes.CANVASFORMTEMPORARY,
				targetEngagementId: stateDocument.engagementId,
				targetDocumentSource: _documentSource,
				customDocumentName: documentName.trim(),
				copyNameBehavior: {behavior: CopyDocumentNameBehaviorType.CustomDocumentName}
			};

			dispatch(createDocumentCopy(stateDocument.engagementId, stateDocument.id, copyArgs))
				.then((document) => {
					if (taskIds()) {
						createTaskDocumentRelationAndFormReference(document.id).then(() => {
							setCopyInProgressAndHideModal(false);
						});
					} else {
						setShowAddtoEvidenceModal(false);
						setCopyInProgressAndHideModal(false);
						dispatch(setIsModalOpen(false));
						dispatch(raiseInformationMessage(labels.noTaskAssociatedToastMessage));
					}
				})
				.catch(() => {
					setCopyInProgressAndHideModal(true);
				});
		}
		event && event.stopPropagation();
	};

	async function createTaskDocumentRelationAndFormReference(referenceDocumentId) {
		try {
			// Create task document relation
			dispatch(
				createTaskDocumentRelation(stateDocument.engagementId, referenceDocumentId, documentName.trim(), taskIds())
			);
			// Create form body reference
			await dispatch(
				createFormBodyReference(
					stateDocument.engagementId,
					documentId,
					entityUId,
					referenceDocumentId,
					documentTabLayoutTabs.evidenceName,
					sectionId
				)
			);
		} catch (error) {
			setCopyInProgressAndHideModal(true);
		} finally {
			if (requireValidations) window.dispatchEvent(new CustomEvent(clientSideEventNames.getValidations));
		}
	}

	const setCopyInProgressAndHideModal = (isError) => {
		setCopyInProgress(false);
		if (!isError) {
			setShowAddtoEvidenceModal(false);
		}
	};

	const onMoveToEvidence = (event) => {
		if (activeTab === relatedDocumentsTab.TEMPORARY) {
			dispatch(
				updateDocumentMetadata(engagementId, stateDocument.id, {
					documentTypeId: Utility.getEvidenceDocumentTypeFromTemporaryDocumentType(stateDocument.documentTypeId)
				})
			)
				.then(() => {
					dispatch(
						createFormBodyReference(
							stateDocument.engagementId,
							documentId,
							entityUId,
							stateDocument.id,
							documentTabLayoutTabs.evidenceName,
							sectionId
						)
					);
				})
				.then(() => {
					getRelatedDocuments();
				});
		}
	};

	const documentNameControls = () => {
		let docNameControlsRender = <></>;

		if (!isDisabled) {
			docNameControlsRender = (
				<MotifTooltip
					placement={'top'}
					hideCloseButton
					trigger={
						<Icon
							src={fileIcFileDownload24px}
							id="move-document"
							className="medium addToEvidence"
							onClick={(event) => {
								onMoveToEvidence(event);
								event.stopPropagation();
							}}
						/>
					}
					className="hideTooltipClose documentNameControlsTooltip"
					variant="alt"
				>
					{labels.moveToEvidenceLabel}
				</MotifTooltip>
			);
		}

		return docNameControlsRender;
	};

	return (
		<RelatedDocumentsItemWrapper className="relatedDocumentsItemWrapperContainer">
			<section
				key={stateDocument.id}
				className={`relatedDocuments__row ${isTargetEng && !stateDocument.isShared ? 'disable' : ''} ${itemClassName}`}
			>
				<section className="relatedDocumentDocName">
					<DocumentName
						key={'docName' + stateDocument.id}
						actionTag={isPriorPeriodEvidence ? 'openr' : undefined}
						confidentialityTypeId={stateDocument.confidentialityTypeId}
						documentChangeTypeId={stateDocument.documentChangeTypeId}
						documentId={stateDocument.id}
						documentTasks={stateDocument.tasks}
						canvasFormOpenType={canvasFormOpenType}
						documentName={stateDocument.documentName}
						documentTypeId={stateDocument.documentTypeId ?? stateDocument.documentType}
						documentStatusId={stateDocument.documentStatusId}
						contentContractId={stateDocument.contentContractId}
						contentUri={stateDocument.contentURI}
						enableOpenDocument={showOptions}
						engagementId={stateDocument.engagementId}
						entityUId={entityUId}
						entities={stateDocument.entities}
						hideCheckBox
						fileExt={stateDocument.fileExt}
						fileSizeKB={stateDocument.fileSizeKB}
						hasComments={stateDocument.hasComments}
						hasHiddenSheets={stateDocument.hasHiddenSheets}
						hasHighlights={stateDocument.hasHighlights}
						isConflicted={stateDocument.isConflicted}
						isReadOnly={stateDocument.isReadOnly}
						isReturned={stateDocument.isReturned}
						isShared={stateDocument.isShared}
						getRelatedDocuments={getRelatedDocuments}
						lastModifiedFullName={stateDocument.lastModifiedFullName + ' '}
						documentEditUserName={stateDocument.documentEditUserName}
						documentEditUserCreateDate={stateDocument.documentEditUserCreateDate}
						documentNameControls={showTemporaryOptions ? documentNameControls : null}
						menuOptions={
							isPriorPeriodEvidence
								? priorPeriodOptions
								: activeTab === relatedDocumentsTab.TEMPORARY
								? undefined
								: activeTab === relatedDocumentsTab.EXTERNAL_DOCUMENTS
								? externalDocumentOptions
								: evidenceOptions
						}
						modifiedDate={stateDocument.modifiedDate}
						onDocumentDeleted={handleOnDocumentDeleted}
						removeDocumentFromBody={
							isFromRelatedDocumentsModal === true ? removeRelatedDocument : removeDocumentFromBody
						}
						showConfidential
						showCurrentUserInfo
						showLastModifiedUserInfo={stateDocument.lastModifiedFullName ? true : false}
						showMenuOptions={showDocumentOptions}
						showShared
						size="large"
						trackChange={stateDocument.trackChange}
						viewKey={viewKey}
						isEPSignoffRequired={stateDocument.isEPSignoffRequired}
						isEPSignoffUserRequired={stateDocument.isEPSignoffUserRequired}
						isEQRSignoffRequired={stateDocument.isEQRSignoffRequired}
						isEQRSignoffUserRequired={stateDocument.isEQRSignoffUserRequired}
						smartEvidenceSourceId={stateDocument.smartEvidenceSourceId}
						smartEvidenceSourceEntityId={stateDocument.smartEvidenceSourceEntityId}
						hasAnySystemAssociated={stateDocument.hasAnySystemAssociated}
						showPriorPeriodMenuOptions={showPriorPeriodOptions}
						showTemporaryMenuOptions={showTemporaryOptions}
						showExternalDocumentMenuOptions={showExternalDocumentOptions}
						onAddToEvidence={(event) => {
							showAddToEvidenceModal(event);
							event.stopPropagation();
						}}
						parentName={parentName}
						isDragAndDropDoc={stateDocument.isDragAndDrop}
						filteredEntityType={filteredEntityType}
						isGroupRiskAssessmentSection={isGroupRiskAssessmentSection}
						groupInstructionDrawer={groupInstructionDrawer}
						instructionId={instructionId}
						hasRelateTask={hasRelateTaskOption}
						tooltipPosition="top"
						isModalOpen={isModalOpen}
						isDisabled={isDisabled}
					/>
				</section>
				{showNotes &&
					(showDocumentOptions || showMenuOptions === false) &&
					activeTab !== relatedDocumentsTab.PRIOR_PERIOD &&
					!showExternalDocumentOptions && (
						<section className="body-quick-reference_row_review-notes">
							<NotesCount
								engagementId={engagementId}
								viewKey={viewKey}
								entityUId={entityUId}
								document={stateDocument}
								isDisabled={inProgress || isPriorPeriodEvidence || isDisabled}
							/>
						</section>
					)}
				<AddToEvidence
					textAreaError={textAreaError}
					textAreaErrorMessage={errorMessage}
					entityUId={entityUId}
					stateDocument={stateDocument}
					isLoading={copyInProgress}
					show={showAddtoEvidenceModal}
					handlerTextAreaOnChange={handlerTextAreaOnChange}
					onOkClick={handleOnClickAddToEvidence}
					onHide={() => {
						setShowAddtoEvidenceModal(false);
						setTextAreaError(false);
					}}
					isAresView={isAresView}
					closeError={clearError}
					documentName={documentName}
				/>
				{!(showTemporaryOptions || showExternalDocumentOptions) && showSignOffs && (
					<section className="body-quick-reference__row__sign-offs">
						<SignOffs
							documentSignOffs={Array.isArray(approvals) ? approvals : []}
							userDateFormat={userPreferences.dateFormat}
							engagementId={stateDocument.engagementId}
							document={stateDocument}
							docTypeId={stateDocument.documentTypeId}
							direction="right"
							entityUid={entityUId}
							isDisabled={inProgress || isPriorPeriodEvidence || isDisabled}
							setDocument={(document) => {
								setDocument(document);
							}}
							onSignOffAdded={(approval) => {
								setApprovals(approvals.concat(approval));
							}}
							onSignOffRemoved={(removedApproval) => {
								setApprovals(
									approvals.filter((approval) => {
										return removedApproval.approvalId !== approval.approvalId;
									})
								);
							}}
							parentContainerClassName={parentContainerClassName}
						/>
					</section>
				)}
				{showRelatedTasks && (
					<section className="body-quick-reference__row__related-tasks">
						<RelatedTasksIcon relatedTasks={relatedTasks} documentId={stateDocument.id} isUploadLoading={inProgress} />
					</section>
				)}
			</section>
		</RelatedDocumentsItemWrapper>
	);
}

const RelatedDocumentsItemWrapper = styled.section`
	width: 100%;
	.relatedDocuments__row {
		display: flex;
		justify-content: space-between;
		align-items: center;
		padding: 0;
		position: relative;
		.relatedDocumentDocName {
			display: inline-flex;
			width: calc(100% - var(--px-290));
			position: relative;
			height: var(--px-64);
			.DocumentNameWrapper {
				&.AdvanceDocName {
					width: 100% !important;
					padding: var(--px-8) 0 var(--px-8) var(--px-16);
					.ProgressBarContainer {
						min-width: var(--px-40);
						text-align: center;
						display: inline-flex;
						margin-right: var(--px-30);
						.motif-progress-bar-wrapper {
							.motif-progress-bar {
								svg {
									width: auto;
									height: auto;
									fill: transparent;
								}
							}
						}
					}
				}
			}
			.DocumentNameContainer {
				align-items: center;
				.DocumentNameDetails {
					.DocumentName {
						display: inline-block;
						width: calc(100% - var(--px-150));
						.last-modified,
						.currently-modified,
						.coedit-mode-complete {
							font-size: var(--px-12);
						}
						.coedit-mode-complete {
							display: flex;
							.coedit-mode-complete-label {
								margin-right: var(--px-3);
								max-width: 90%;
								display: inline-block;
							}
						}
						.DocumentName {
							font-size: var(--px-14);
							font-weight: 400;
							line-height: var(--px-20);
							color: var(--neutrals-900);
							width: 100%;
							display: inline-block;
						}
					}
				}
				&.name-link {
					&:hover,
					&:focus {
						text-decoration: none !important;
					}
				}
			}
			.cogmenu-btn {
				display: flex;
				height: var(--px-35);
				align-items: center;
				svg {
					fill: var(--neutrals-700) !important;
					color: var(--neutrals-700) !important;
					width: var(--px-20);
					height: var(--px-20);
				}
				.show-pop-content {
					&.bottom {
						top: var(--px-30);
					}
					&.top {
						bottom: var(--px-45);
					}
				}
			}
		}
		.small {
			padding: 0;
			width: 100%;
			svg {
				width: var(--px-16);
			}
		}
		section:not([class]) {
			color: var(--neutrals-700);
			font-size: var(--px-12);
			padding-left: var(--px-5);
			.modifiedName {
				margin-right: var(--px-10);
			}
		}
		.DocumentNameWrapper {
			padding: var(--px-10) 0 var(--px-10) var(--px-20);
			.DocumentNameDetails {
				display: inline-flex;
				.DocumentNameText {
					.DocumentName {
						height: auto;
					}
				}
				/* .DocumentShared {
					margin-left: auto;
					margin-right: var(--px-10);
				} */
				.documentName-icons {
					svg {
						color: var(--neutrals-900);
						fill: var(--neutrals-900);
						path {
							fill: var(--neutrals-900);
						}
						width: var(--px-20);
						height: var(--px-20);
					}
					.StyledDisplayDocumentSignoffRequirements {
						margin-top: var(--px-2);
					}
					.document-checked-out-icon {
						margin-right: var(--px-10);
					}
					.motif-tooltip-trigger-wrap {
						align-items: flex-start;
						width: 100%;
					}
					.addToEvidence {
						margin: 0 var(--px-10) 0 0;
						svg {
							width: var(--px-33) !important;
							height: var(--px-33) !important;
							/* transform: rotate(90deg); */
							fill: var(--neutrals-900) !important;
						}
					}
				}
			}
			&.small {
				.DocumentNameDetails {
					.documentName-icons {
						svg {
							color: var(--neutrals-900);
							fill: var(--neutrals-900);
							path {
								fill: var(--neutrals-900);
							}
						}
						.motif-tooltip-trigger-wrap {
							.document-confidential {
								color: var(--neutrals-900);
								svg {
									width: var(--px-16);
									height: var(--px-16);
									max-width: var(--px-16);
									max-height: var(--px-16);
									fill: var(--neutrals-900);
									path {
										fill: var(--neutrals-900);
									}
								}
							}
						}
					}
				}
			}
		}
		&.disable {
			user-select: none;
			pointer-events: none;
			.DocumentNameWrapper {
				color: var(--neutrals-500);
			}
		}
		.body-quick-reference__row__related-tasks {
			width: var(--px-100);
			display: flex;
			justify-content: center;
			margin-top: var(--px-10);
			.relatedTasksSection {
				.ellipses {
					margin-top: var(--px-5);
				}
			}
			& + .body-quick-reference_remove {
				display: none;
			}
		}
		.body-quick-reference_remove {
			height: var(--px-64);
			.motif-icon {
				padding: var(--px-8) var(--px-16) var(--px-8) var(--px-12);
				height: var(--px-48);
				display: flex;
				align-items: center;
				svg {
					width: var(--px-20);
					height: var(--px-20);
					color: var(--neutrals-900);
					path {
						color: var(--neutrals-900);
					}
				}
			}
		}
	}

	.relatedDocumentsWrapper {
		display: flex;
	}
	.body-quick-reference_row_review-notes {
		border-right: var(--px-1) solid var(--neutrals-300);
		height: var(--px-60);
		padding: var(--px-10) var(--px-10);
		width: var(--px-70);
		display: inline-flex;
		justify-content: center;
		align-items: center;
		.notesControl {
			padding: 0;
			.btn-default {
				padding: 0;
				margin: 0;
				span {
					color: var(--neutrals-900);
					svg {
						fill: var(--neutrals-900);
					}
				}
				&.simple-button {
					height: var(--px-18);
					width: var(--px-18);
					border: var(--px-1) solid var(--neutrals-900);
					border-radius: var(--px-50);
					color: var(--neutrals-900);
					font-size: var(--px-12);
					span {
						padding: 0;
						width: 100%;
						height: 100%;
						display: flex;
						align-items: center;
						justify-content: center;
					}
					&:hover {
						background-color: var(--neutrals-900);
						span {
							color: var(--neutrals-00white);
							svg {
								fill: var(--neutrals-00white);
							}
						}
					}
					&.removeBorder {
						border: 0;
						&:hover {
							background-color: transparent;
							span {
								color: var(--neutrals-900);
								svg {
									fill: var(--neutrals-900);
								}
							}
						}
					}
				}
			}
		}
	}
	.body-quick-reference__row__sign-offs {
		display: flex;
		align-items: center;
		padding: 0 var(--px-10);
		height: var(--px-38);
		width: var(--px-200);
	}
`;
